export const enterpriseContractType = {
  STANDARD: 'STANDARD',
  SELF_SERVE: 'SELF_SERVE',
} as const;

export const enterpriseContractUtilizationType = {
  NO_LIMIT: 'NO_LIMIT',
  ENROLLMENT_CAP: 'ENROLLMENT_CAP',
  USER_LICENSE: 'USER_LICENSE',
  USER_LICENSE_WITH_ENROLLMENT_CAP: 'USER_LICENSE_WITH_ENROLLMENT_CAP',
} as const;

export const enterpriseContractActivationType = {
  IMMEDIATE: 'IMMEDIATE',
  SUPERUSER: 'SUPERUSER',
  AUTO: 'AUTO',
} as const;

export default {
  enterpriseContractType,
  enterpriseContractUtilizationType,
  enterpriseContractActivationType,
};
